import BaseApiRequest from "./BaseApiRequest";
import { EXISTINGUSER_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class ExistingUser extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {
    credential: "",
  };

  constructor(userDetail) {
    super();
    this.body.credential = userDetail.credential;
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return EXISTINGUSER_URL;
  };

  getBody = () => {
    return this.body;
  };
}
